import React from 'react'

function Cloud() {
    return (
  <>
      {/* Hero Area */}
      <div 
        className="inner-page-hero-area" 
        style={{
          backgroundImage: 'url(assets/img/all-images/bg/hero-bg1.png)',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }}
      >
        <img src="assets/img/elements/elements5.png" alt="" className="elements5" />
        <img src="assets/img/elements/elements4.png" alt="" className="elements4" />
        <img src="assets/img/elements/elements1.png" alt="" className="elements1 keyframe5" />
        <img src="assets/img/elements/elements16.png" alt="" className="elements16" />

        <div className="container">
          <div className="row">
            <div className="col-lg-6 m-auto">
              <div className="inner-header text-center heading1">
                <h1>Cloud Solutions</h1>
                <div className="space28"></div>
                <a href="/">
                  Home <i className="fa-solid fa-angle-right"></i> 
                  <span>Cloud Solutions</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Service Sidebar Area */}
      <div className="service-sidebar-area sp1">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 m-auto">
              <div className="service2-widget-sidebar" style={{padding: '0 !important'}}>
                <div className="img1 reveal image-anime">
                  <img src="assets/img/all-images/service/service-img22.png" alt="" />
                </div>
                <div className="space32"></div>
                <h3>Cloud Solutions</h3>
                <div className="space20"></div>
                <p>
                  Cloud computing empowers businesses to scale efficiently, reduce infrastructure costs, and stay agile. Our Cloud Solutions service helps you migrate, deploy, and manage applications across platforms like AWS, Azure, and Google Cloud, ensuring top performance and security.
                </p>
                <div className="space14"></div>
                
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <ul className="list">
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>Cloud Architecture Design</b>
                      </li>
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>Migration & Modernization</b>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <ul className="list">
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>Serverless & Containerized Applications</b>
                      </li>
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>Data Storage & Backup Solutions</b>
                      </li>
                    </ul>
                  </div>
                </div>
                
                <div className="space32"></div>
                <div className="pera-box">
                  {/* <h4>Safeguard Your Business With Advanced Cybersecurity</h4> */}
                  <div className="space12"></div>
                  <p>
                  Cloud technology enables on-demand scalability, robust security, and real-time collaboration.
                  </p>
                </div>
                
                <div className="space18"></div>
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="space30"></div>
                    <div className="img1 reveal image-anime">
                      <img src="assets/img/all-images/service/service-img13.png" alt="" />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="space30"></div>
                    <div className="img1 reveal image-anime">
                      <img src="assets/img/all-images/service/service-img14.png" alt="" />
                    </div>
                  </div>
                </div>
                
                <div className="space32"></div>
                <h3>What We Provide</h3>
<div class="space20"></div>
<ul className="check-list">
  <li>
  <b>Cloud Strategy & Consulting</b> – Assessment and roadmap tailored to your business goals.
</li>
<li>
  <b>Cloud Migration</b> – Smooth transfer of applications, data, and workloads with minimal downtime.
</li>
<li>
  <b>Infrastructure Management</b> – Ongoing monitoring, patching, and performance optimization
</li>
<li>
  <b>DevOps & CI/CD</b> – Automated deployment pipelines for faster, reliable releases.
</li>
<li>
  <b>Security & Compliance</b> – Identity management, encryption, and regulatory adherence.
</li>
<li>
  <b>Cost Optimization</b> – Tools and practices to maximize ROI and control spending.
</li>
<li>
  <b>Growth-Oriented Approach</b> – Strategies designed to scale your business.
</li>
</ul>


                
                <div className="space48"></div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
    )
}

export default Cloud
